import React, { Component } from "react";
import Helmet from "react-helmet";
import { lang } from "../../../il8n/lang";
import { connect } from "react-redux";
import Caro from "../../Carousels/Caro/Caro";
import Collectioncaro from "../../Collectioncaro/Collectioncaro";
import Productcaro from "../../Productcaro/Productcaro";
import Variants from "../../Variants/Variants";
import GeneralModal from "../../GeneralModal/GeneralModal";
import VideoPlayer from "../../VideoPlayer/VideoPlayer";
import ReactGA from "react-ga";
import { cdnBase } from "../../../const";

import { toggleInterstitial } from "../../../Actions/Index";
import "./Home.css";

/**
 * Home
 * @constructor
 */

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(toggleInterstitial(false, "", ""));
  }

  toggleModal(vid) {
    this.setState((state) => ({
      modalOpen: !state.modalOpen,
      currentvid: vid,
    }));
  }
  render() {
    let { gaToggle } = this.props;
    return (
      <div>
        <Helmet title={lang.home.title + lang.helmet.siteTitle} />
        <GeneralModal
          open={this.state.modalOpen}
          toggleModal={this.toggleModal}
        >
          <VideoPlayer
            type={"default"}
            activeVid={this.state.currentvid}
            warn={lang.warnings.enableIframes}
            autoPlay={true}
            loop={false}
          />
        </GeneralModal>
        <div className="home">
        <div
            className="section homebanner homebanner--bgImg"
            style={{
              backgroundImage: `url('${lang.home.sections.hero.bgImg}')`,
            }}
          >
            <div className="flex-container flex">
              <div className="homebanner-img">
                <img
                  // className="mobileonly"
                  src={lang.home.sections.hero.img}
                ></img>
              </div>
              
              {/* <div className="flex-col-sm-5 "> */}
                <div className="homebanner-copy">
                  <h1 dangerouslySetInnerHTML={{__html: lang.home.sections.hero.heading}}>
                  </h1>
                  <p>{lang.home.sections.hero.copy}</p>
                  {/* <a href={lang.home.sections.hero.cta.link}>
                    <button>{lang.home.sections.hero.cta.copy}</button>
                  </a> */}
                </div>
              {/* </div> */}
            </div>
          </div>


          <div className="section apps">
            <div className="flex-container">
              <div className="flex-col-md-6">
                <img src={lang.home.sections.steps.img}></img>
              </div>
              <div className="flex-col-md-6">
                <h1>
                  {/* <span className="gradient-text"> */}
                  {lang.home.sections.steps.heading}
                  {/* </span> */}
                </h1>
                <ul>
                  {lang.home.sections.steps.steps.map((step, index) => (
                    <li key={index}>
                      <div className="listcircle" >{index + 1}</div>
                      <span dangerouslySetInnerHTML={{__html: step}}></span>
                    </li>
                  ))}
                </ul>
                <span>{lang.home.sections.steps.quietCopy} </span>
                
              </div>
            </div>
          </div>

          


          {lang.home.sections.app && (
            <div className="section apps">
              <div className="flex-container">
                <Caro
                  respSlidesToShow={1}
                  slidesToShow={1}
                  frameOverflow={false}
                  insertClass={"caro--homeApp"}
                >
                  {lang.home.sections.app.slides.map((slide, index) => {
                    let img = slide.img;
                    return (
                      <div
                        className="caro__item flex-row flex-row--align-h-center"
                        key={slide.heading + index}
                      >
                        <div className="flex-col-md-6">
                          <img alt={slide.heading} src={img} />
                        </div>

                        <div className={`flex-col-md-6`}>
                          <div className="custombanner">
                            <h2>{slide.heading}</h2>
                            <p>{slide.copy}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Caro>
              </div>
            </div>
          )}

          {/*PRODUCT CAROUSEL************************************************************/}
          <div className="section products">
            <Productcaro />
          </div>

          



          {/*WHERE TO BUY************************************************************/}
          {lang.home.sections.retailers && (
            <div className="section retailers" id="wheretobuy">
              <div className="flex-container">
                <div className="home__header">
                  <h1>{lang.home.whereToBuy} </h1>
                </div>
                <div className="retailers-list flex-row flex-row--align-h-center">
                  {lang.home.sections.retailers.retailers.map(
                    (retailer, index) => (
                      <div className="retailer" key={`retailers___${index}`}>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => {
                            if (retailer.href !== "") {
                              this.props.dispatch(
                                toggleInterstitial(true, retailer.href)
                              );
                            }
                          }}
                        >
                          <img
                            className="retailer-img"
                            id={`${retailer.id}`}
                            src={retailer.img}
                            alt={retailer.name}
                          />
                        </a>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    lang: state.lang,
    gaToggle: state.gaToggle,
  };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Pages/Home/Home.js